import { Grid } from "@material-ui/core"
import { InputTextMaster, MasterButton } from "App/Component/ui"
import React, { useState } from "react"
import "./saldo.scss"
import { Person, Refresh } from "@material-ui/icons"
import ModalListKunjungan from "App/Component/layout/Penjualan/InputPenjualan/ui/Perhitungan/Modal/ModalMuat/ModalListKunjungan"
import { urlGetKunjungan } from "."
import {
  defaultDateInputDisplay,
  formatNumber,
  isNull,
} from "App/utils/helpers"
function FormDetailKunjungan({
  formDetailKunjungan,
  setFormDetailKunjungan,
  setNewDataSaldo,
  totalSaldo,
  totalHistory,
  value,
  handleClickCetak
}) {
  const [showModalListKunjungan, setShowModalListKunjungan] = useState(false)

  const handleClickSelect = async (row) => {
    await setFormDetailKunjungan({
      kunjungan_id: row.id,
      jenis_layanan_name: row.layanan_name,
      tanggal_masuk: defaultDateInputDisplay(row.date, true),
      rm_id: row.patients_id,
      tagihan_id: row.tagihan_id,
      rm_name: row?.isexternalrm ? row.rm_name_external : row.rm_name,
    })
    setShowModalListKunjungan(false)
    await setNewDataSaldo(row.id)
  }

  const isBuka = value === 0 || value === 1 ? "buka" : "tutup"
  return (
    <>
      {showModalListKunjungan && (
        <ModalListKunjungan
          setShowModal={setShowModalListKunjungan}
          handleClickSelect={handleClickSelect}
          url={urlGetKunjungan}
          type="custom"
        />
      )}

      <div className="form-saldo-detail-kunjungan">
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            gap: "0.5rem",
            marginBottom: "1rem",
          }}
        >
          <MasterButton
            type='button'
            color={isNull(formDetailKunjungan.kunjungan_id) || (totalSaldo??0) <= 0 ? "secondary" : "warning"}
            name={"KWITANSI"}
            disabled={isNull(formDetailKunjungan.kunjungan_id) || (totalSaldo??0) <= 0}
            onClick={() => handleClickCetak(totalSaldo??0)}
            size='md'
          />

          <MasterButton
            type={"button"}
            color="warning"
            outline={true}
            name="REFRESH"
            size="sm"
            onClick={() => setNewDataSaldo(formDetailKunjungan.kunjungan_id)}
            withIcon={true}
            icon={
              <Refresh
                style={{
                  width: "17px",
                }}
                fill="#F09F00"
              />
            }
          />

          <MasterButton
            type={"button"}
            color="green"
            outline={true}
            name="CARI KUNJUNGAN"
            size="sm"
            onClick={() => setShowModalListKunjungan(!showModalListKunjungan)}
            withIcon={true}
            icon={<Person width="17px" height="17px" />}
          />
        </div>
        <Grid container spacing={3}>
          <Grid item sm={4}>
            <div className={`saldo-total ${isBuka}`}>
              <div className={`box-buka `}>{isBuka}</div>

              <div className="total-saldo">
                {value === 0 || value === 1
                  ? !isNull(totalSaldo)
                    ? formatNumber(totalSaldo)
                    : "0"
                  : !isNull(totalHistory)
                  ? formatNumber(totalHistory)
                  : "0"}
              </div>
            </div>
          </Grid>
          <Grid item sm={8}>
            <Grid container spacing={1}>
              <Grid item sm={4}>
                <InputTextMaster
                  name="kunjungan_id"
                  label="ID KUNJUNGAN"
                  id="kunjungan_id"
                  value={formDetailKunjungan.kunjungan_id}
                  readOnly
                  disabled
                  placeholder="ID Kunjungan"
                />
              </Grid>
              <Grid item sm={4}>
                <InputTextMaster
                  name="jenis_layanan_name"
                  label="JENIS LAYANAN"
                  id="jenis_layanan_name"
                  value={formDetailKunjungan.jenis_layanan_name}
                  readOnly
                  disabled
                  placeholder="Jenis Layanan"
                />
              </Grid>
              <Grid item sm={4}>
                <InputTextMaster
                  name="tanggal_masuk"
                  label="TANGGAL MASUK"
                  id="tanggal_masuk"
                  value={formDetailKunjungan.tanggal_masuk}
                  readOnly
                  disabled
                  type="datetime-local"
                  placeholder="Tanggal Masuk"
                />
              </Grid>
              <Grid item sm={4}>
                <InputTextMaster
                  name="rm_name"
                  label="NAMA RM"
                  id="rm_name"
                  value={formDetailKunjungan.rm_name}
                  readOnly
                  disabled
                  placeholder="Nama RM"
                />
              </Grid>
              <Grid item sm={4}>
                <InputTextMaster
                  name="rm_id"
                  label="ID RM"
                  id="rm_id"
                  value={formDetailKunjungan.rm_id}
                  readOnly
                  disabled
                  placeholder="ID RM"
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </div>
    </>
  )
}

export default FormDetailKunjungan
